import axios from 'axios'

import {
  AllCitiesParams,
  AllCitiesResponse,
  AllParkingsParams,
  AllParkingsResponse,
  AllParkingsResponseV2,
  ParkingsByCityParams,
  ParkingsByCityResponseV2,
  ParkingsBySlugParams,
  ParkingsBySlugResponse,
  ParkingsPlanParams,
  ParkingsPlanResponse,
  instance
} from '@/service'

import { ApiPaths } from './apiPaths'

const isLocalhost = () => {
  if (typeof window !== 'undefined') {
    return (
      window.location.hostname === 'localhost' ||
      window.location.hostname === '127.0.0.1'
    )
  }
  return false
}

const getHttpClient = () => {
  return isLocalhost() ? instance : axios
}

export const fetchParkings = async ({
  params
}: {
  params?: AllParkingsParams
}): Promise<AllParkingsResponse> => {
  try {
    const { data } = await getHttpClient().get<AllParkingsResponse>(
      ApiPaths.API_V1_PARKINGS,
      { params }
    )
    if (data) {
      return data
    } else {
      throw new Error('Brak danych z API')
    }
  } catch (e) {
    console.error(e)

    throw e
  }
}

export const fetchParkingsV2 = async ({
  params
}: {
  params?: AllParkingsParams
}): Promise<AllParkingsResponseV2> => {
  try {
    const { data } = await getHttpClient().get<AllParkingsResponseV2>(
      ApiPaths.API_V2_PARKINGS,
      { params }
    )
    if (data) {
      return data
    } else {
      throw new Error('Error')
    }
  } catch (e) {
    console.error(e)

    throw e
  }
}

export const fetchParkingBySlug = async ({
  slug,
  params
}: {
  slug: string
  params?: ParkingsBySlugParams
}) => {
  try {
    const { data } = await getHttpClient().get<ParkingsBySlugResponse>(
      `${ApiPaths.API_V1_PARKINGS}/${slug}`,
      { params }
    )
    return data
  } catch (e) {
    console.error(e)
  }
}

export const fetchParkingByPlan = async ({
  slug,
  params
}: {
  slug: string
  params?: ParkingsPlanParams
}) => {
  try {
    const { data } = await getHttpClient().get<ParkingsPlanResponse>(
      `/api/v2/parkings/${slug}/plans`,
      {
        params
      }
    )
    return data
  } catch (e) {
    console.error(e)
  }
}

export const fetchAllCities = async ({
  params
}: {
  params?: AllCitiesParams
}) => {
  try {
    const { data } = await getHttpClient().get<AllCitiesResponse>(
      ApiPaths.API_V1_CITIES,
      {
        params
      }
    )
    return data
  } catch (e) {
    console.error(e)
  }
}

export const fetchByCityV2 = async (
  city: string,
  params: ParkingsByCityParams
): Promise<ParkingsByCityResponseV2> => {
  try {
    const { data } = await getHttpClient().get<ParkingsByCityResponseV2>(
      `${ApiPaths.API_V2_CITIES}/${city}/parkings`,
      { params }
    )
    if (data) {
      return data
    } else {
      throw new Error('Error')
    }
  } catch (e) {
    console.error(e)

    throw e
  }
}
